export function isAlphabet(string: string, { withNumber = false } = {}): boolean {
  if (withNumber) return /^([^!@#$%^&*(),.?":;{}|<>\\/[\]=]*)$/.test(string);
  return /^([^0-9\u0660-\u0669\u06f0-\u06f9!@#$%^&*(),.?":;{}|<>\\/[\]=]*)$/.test(string);
}
